import axios from 'axios';
import Notify from 'quasar/src/plugins/Notify.js';;

export default {
    // user actions
    authenticatingUser(context, userCredentials) {
        console.log('userCredentials: ', userCredentials);
        axios
            .post(
                `${context.getters.url}/Auth/Login`,
                userCredentials,
                //     , {
                //     withCredentials: true,
                // }
            )
            .then((res) => {
                if (res.data.success && res.data.validationState == 0) {
                    let token = res.data.data.accessToken;
                    sessionStorage.setItem('token', token, res);

                    token = `Bearer ${token}`;

                    axios.defaults.headers.common['Authorization'] = token;
                    axios.defaults.headers['Authorization'] = token;
                    axios.defaults.headers['Content-Type'] = 'application/json';
                    axios.defaults.headers['Cache-Control'] = 'no-cache';
                    axios.defaults.headers['Pragma'] = 'no-cache';
                    axios.defaults.headers['Expires'] = '0';
                    axios.defaults.headers['Access-Control-Allow-Origin'] = '*';
                    axios.defaults.withCredentials = false;

                    context.commit('loginLoaderHandler', false);
                    context.commit('loginHandler', { ...res.data.data.user, isloggedIn: true });
                    context.dispatch('getUserMenus');
                    // context.dispatch('handleFetchItems')
                } else {
                    context.commit('loginErrorHandler', res?.data?.message);
                    context.commit('loginLoaderHandler', false);
                }
            })
            .catch((err) => {
                console.log('Full error:', err);

                if (err.response) {
                    // Server ne response diya — 400, 401, 500 etc.
                    console.log('Status:', err.response.status);
                    console.log('Message:', err.response.data?.message);

                    context.commit(
                        'loginErrorHandler',
                        err.response.data?.message || err?.message  || 'Login failed.',
                    );
                } else if (err.request) {
                    // Request send hui, lekin response nahi mila
                    console.log('Network error:', err.message);

                    context.commit(
                        'loginErrorHandler',
                        'Unable to connect to the server. Please check your connection or try again.',
                    );
                } else {
                    // Request banate waqt error
                    console.log('Request error:', err.message);

                    context.commit('loginErrorHandler', err.message || 'Something went wrong.');
                }

                context.commit('loginLoaderHandler', false);
            });

        //  context.commit('loginLoaderHandler', false);
        // context.commit('loginHandler', {isloggedIn: true });
    },
    // items
    handleFetchItems(context) {
        console.log('context: ', context);
        axios
            .get(`${context.getters.url}/Display/getErpItems`)
            .then((res) => {
                console.log('res: ', res);
                if (res.data.success) {
                    context.commit('setItems', res.data.data);
                }
            })
            .catch((err) => {
                const error = err.response || err;
                console.error(error);
            });
    },
    // menues
    getUserMenus(context) {
        axios
            .get(`${context.getters.url}/Auth/Menus`)
            .then((res) => {
                console.log('res: ', res);
                context.commit('setUserMenu', res.data);
            })

            .catch((err) => {
                const error = err.response || err;
                console.log(error);
                context.commit('logOutHandler');
            });
    },
    // unathorized Error
    triggerUnauthorizedError(context, err) {
        console.log('err: ', err);
        if (err.response) {
            if (err.response.status === 401) {
                if (context.getters.getCurrentAuthState == false) {
                    context.dispatch('refreshSession');
                    setTimeout(() => context.commit('setAuthState', false), 60000);
                }
                console.log(context.commit('logOutHandler'));
                Notify.create({
                    message: 'Session Expired!',
                    timeout: 4000,
                    width: '600px',
                    'text-color': 'white',
                    type: 'negative',
                    progress: true,

                    actions: [
                        {
                            icon: 'close',
                            color: 'white',
                        },
                    ],
                });
            } else
                Notify.create({
                    message: err.message,
                    timeout: 4000,
                    width: '600px',
                    'text-color': 'white',
                    type: 'negative',
                    progress: true,

                    actions: [
                        {
                            icon: 'close',
                            color: 'white',
                        },
                    ],
                });
        }
    },
    refreshSession(context) {
        context.commit('setAuthState', true);

        fetch(`${context.getters.url}/Auth/refresh`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({}),
        })
            .then(async (response) => {
                if (!response.ok) {
                    throw new Error(`Refresh failed: ${response.status}`);
                }

                return response.json();
            })
            .then((data) => {
                console.log('data: ', data, context.getters);
                let token = `Bearer ${data.data.accessToken}`;
                axios.defaults.headers.common['Authorization'] = token;
                axios.defaults.headers['Authorization'] = token;
                sessionStorage.setItem('token', data.data.accessToken);
                context.commit('loginHandler', {
                    ...context.getters.getUserData,
                    isloggedIn: Boolean(data.data),
                });
            })
            .catch((err) => {
                const error = err.response || err;
                console.log(error);
                // context.commit('logOutHandler');
            });
        // axios
        //     .post(
        //         `${context.getters.url}/Auth/refresh`,
        //         {},
        //         {
        //             withCredentials: true,
        //         },
        //     )
        //     .then((res) => {
        //         context.commit('loginHandler', {
        //             ...res.data.data.user,
        //             isloggedIn: res.data.data ? true : false,
        //         });

        //     })

        //     .catch((err) => {
        //         const error = err.response || err;
        //         console.log(error);
        //         context.commit('logOutHandler');
        //     });
    },
};
